const initialState = {
  uid: null,
  email: null,
  emailName: null,
  realName: null,
  nickName: null,
  teams: null,
  introduction: null,
  slackId: null,
  slackName: null,
  images: null,
  position: null,
  admin: false,
  initialized: false
}

const user = (state = initialState, action) => {
  switch (action.type) {
    case 'LOGIN':
      return {
        ...state,
        uid: action.payload.uid,
        email: action.payload.email,
        emailName: action.payload.emailName,
      }

    case 'LOAD_USER_INFO':
      return {
        ...state,
        realName: action.payload.realName? action.payload.realName: state.realName,
        nickName: action.payload.nickName? action.payload.nickName: state.nickName,
        teams: action.payload.teams? action.payload.teams: state.teams,
        introduction: action.payload.introduction? action.payload.introduction: state.introduction,
        slackId: action.payload.slackId? action.payload.slackId: state.slackId,
        slackName: action.payload.slackName? action.payload.slackName: state.slackName,
        images: action.payload.images? action.payload.images: state.images,
        position: action.payload.position? action.payload.position: state.position,
        admin: action.payload.admin? action.payload.admin: state.admin,
        initialized: true
      }

    case 'LOGOUT':
      return {
        uid: null,
        email: null,
        emailName: null,
        realName: null,
        nickName: null,
        teams: null,
        introduction: null,
        slackId: null,
        slackName: null,
        images: null,
        position: null,
        initialized: false
      }

    default:
      return state
  }
}
export default user



// WEBPACK FOOTER //
// ./src/reducers/user.js